import { render } from "./EditImageModal.vue?vue&type=template&id=7badf4e5"
import script from "./EditImageModal.vue?vue&type=script&lang=ts"
export * from "./EditImageModal.vue?vue&type=script&lang=ts"

import "./EditImageModal.vue?vue&type=style&index=0&id=7badf4e5&lang=scss"
script.render = render

export default script